import script from "./AfterPaymentPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AfterPaymentPage.vue?vue&type=script&setup=true&lang=js"

import "./AfterPaymentPage.vue?vue&type=style&index=0&id=d51adf2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d51adf2a"]])

export default __exports__